import Axios from "axios";
import {
    SET_SUPPLIER_TYPE_LIST,
    UNSET_SUPPLIER_TYPE_LIST,
  } from "@/store/mutation-types";
import { saveUpdateSupplierType, getSupplierTypeList } from "@/store/api";
// initial state
const state = {
  getSupplierTypeList: [],
};

const getters = {
  getSupplierTypeList(state) {
    return state.getSupplierTypeList;
  },
};
const mutations = {
  [SET_SUPPLIER_TYPE_LIST](state, data) {
    state.getSupplierTypeList = data;
  },
  [UNSET_SUPPLIER_TYPE_LIST](state) {
    state.getSupplierTypeList = [];
  },
};

const actions = {

  saveUpdateSupplierType({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSupplierType, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSupplierTypeList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getSupplierTypeList, data)
        .then(function (response) {
          commit('SET_SUPPLIER_TYPE_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SUPPLIER_TYPE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
